__turbopack_context__.v({
  "privacy": "Privacy-module-scss-module__9n_AZq__privacy",
});
